import React, { createContext, useContext, useState, useCallback } from 'react';
import { userService } from '@/services/auth/userService.js';

const WalletContext = createContext({});

export const WalletProvider = ({ children }) => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);

  const getBalance = useCallback(async () => {
    try {
      setLoading(true);
      const balanceData = await userService.getBalance();
      setBalance(balanceData);
      return balanceData;
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <WalletContext.Provider value={{ balance, loading, getBalance }}>
      {children}
    </WalletContext.Provider>
  );
};

export const useWallet = () => {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWallet must be used within a WalletProvider');
  }
  return context;
}; 
